import { createStore, combineReducers, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';
import { forgotPasswordReducer, profileReducer, userReducer, allUsersReducer, userDetailsReducer } from './reducers/userReducer';
import { newProductReducer, newReviewReducer, productDetailsReducer, productReducer, productsReducer, productReviewsReducer, reviewReducer, similarProductsReducer } from './reducers/productReducer';
import { cartReducer } from './reducers/cartReducer';
import { saveForLaterReducer } from './reducers/saveForLaterReducer';
import { allOrdersReducer, myOrdersReducer, newOrderReducer, orderDetailsReducer, orderReducer, paymentStatusReducer, retryPaymentReducer } from './reducers/orderReducer';
import { wishlistReducer } from './reducers/wishlistReducer';
import { brandReducer, newBrandReducer, brandDetailsReducer, brandProductsReducer, brandsReducer } from './reducers/brandReducer';
import { categoryReducer, newCategoryReducer, deleteCategoryReducer, updateCategoryReducer, categoryDetailsReducer } from './reducers/categoryReducer';
import { bannerReducer, newBannerReducer, deleteBannerReducer } from './reducers/bannerReducer';

const reducer = combineReducers({
    user: userReducer,
    profile: profileReducer,
    forgotPassword: forgotPasswordReducer,
    products: productsReducer,
    similarProducts: similarProductsReducer,
    productDetails: productDetailsReducer,
    newReview: newReviewReducer,
    cart: cartReducer,
    saveForLater: saveForLaterReducer,
    newOrder: newOrderReducer,
    myOrders: myOrdersReducer,
    paymentStatus: paymentStatusReducer,
    retryPayment: retryPaymentReducer,
    orderDetails: orderDetailsReducer,
    allOrders: allOrdersReducer,
    order: orderReducer,
    newProduct: newProductReducer,
    product: productReducer,
    users: allUsersReducer,
    userDetails: userDetailsReducer,
    reviews: productReviewsReducer,
    review: reviewReducer,
    wishlist: wishlistReducer,
    brands: brandsReducer,
    brand: brandReducer,
    newBrand: newBrandReducer,
    brandDetails: brandDetailsReducer,
    brandProducts: brandProductsReducer,
    categories: categoryReducer,
    newCategory: newCategoryReducer,
    deleteCategory: deleteCategoryReducer,
    updateCategory: updateCategoryReducer,
    categoryDetails: categoryDetailsReducer,
    banners: bannerReducer,
    newBanner: newBannerReducer,
    deleteBanner: deleteBannerReducer,
});

let initialState = {
    cart: {
        cartItems: localStorage.getItem('cartItems')
            ? JSON.parse(localStorage.getItem('cartItems'))
            : [],
        shippingInfo: localStorage.getItem("shippingInfo")
            ? JSON.parse(localStorage.getItem("shippingInfo"))
            : {},
    },
    saveForLater: {
        saveForLaterItems: localStorage.getItem('saveForLaterItems')
            ? JSON.parse(localStorage.getItem('saveForLaterItems'))
            : [],
    },
    wishlist: {
        wishlistItems: localStorage.getItem('wishlistItems')
            ? JSON.parse(localStorage.getItem('wishlistItems'))
            : [],
    },
};

const middleware = [thunk];

const store = createStore(
    reducer,
    initialState,
    composeWithDevTools(applyMiddleware(...middleware))
);

export default store;